/*
  13/10/2026 — khối Pairs well with (snippets/pf-pairs-well.liquid).

  1. Nút "Add to cart" (món không cá nhân hoá): fetch /cart/add.js. cart-added-modal.js bọc sẵn
     fetch nên popup xác nhận tự hiện; số trên icon giỏ thì tự cập nhật ở đây.

  2. Nút "Personalize it" (món Customily): mở trang sản phẩm đó trong hộp thoại.
     Vì sao làm kiểu này: file in + ảnh preview của mỗi dòng hàng do Customily tạo trên trình
     duyệt lúc Add to cart, form tự dựng không tạo ra được. Customily chỉ chạy một widget mỗi
     document (id cố định, một biến `engraver` toàn cục) nên phải có document thứ hai. <iframe src>
     tới trang store bị Shopify chặn (X-Frame-Options: DENY), nhưng tải HTML bằng fetch rồi đưa vào
     `srcdoc` thì không dính header đó, vẫn cùng origin nên /cart/add chạy bình thường.
     Đã thử 13/10/2026: dòng giỏ có đủ `_customily-production-url` và `_customily-preview`.

     Bên trong khung: ẩn header/footer/các section khác, bỏ script đo lường (kẻo mỗi lần mở là một
     lượt xem trang giả), tắt popup "đã thêm" của khung — thêm xong thì đóng hộp thoại và hiện popup
     đó ở trang ngoài.

     Hỏng ở bước nào thì rơi về hành vi gốc của thẻ <a>: sang trang sản phẩm.
*/
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* Chỉ sửa số trên icon thì ngăn kéo giỏ vẫn là HTML lúc tải trang ("Your cart is empty"
     trong khi icon báo 1 — sếp báo 14/10/2026). Phát CartLinesUpdateEvent như product-form.js
     để cart-items-component tự render lại; action 'update' để ngăn kéo không tự bật ra
     chồng lên popup "đã thêm". */
  function refreshCount() {
    fetch(root + 'cart.js', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        /* Không viết import() trực tiếp: CDN Shopify minify file và đổi nó thành require() —
           chết trên trình duyệt (đo 14/10/2026). Không có CSP chặn new Function. */
        return new Function('s', 'return import(s)')('@shopify/events')
          .then(function (events) {
            var Event = events.CartLinesUpdateEvent;
            var deferred = Event.createPromise();
            document.dispatchEvent(new Event({ action: 'update', context: 'cart', lines: [], promise: deferred.promise }));
            deferred.resolve({
              cart: Event.createCartFromAjaxResponse(cart),
              detail: { items: cart.items, itemCount: cart.item_count, source: 'pf-pairs-well' },
            });
          })
          .catch(function () {
            var icon = document.querySelector('cart-icon');
            if (icon && typeof icon.renderCartBubble === 'function') icon.renderCartBubble(cart.item_count);
          });
      })
      .catch(function () {});
  }

  /* ---------- 1. Thêm thẳng vào giỏ ---------- */

  function addDirect(btn) {
    var item = btn.closest('.pf-pairs__item');
    var picker = item && item.querySelector('[data-pf-pairs-variant]');
    if (!picker) return;

    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(picker.value), quantity: 1 }] }),
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        btn.textContent = 'Added ✓';
        refreshCount();
      })
      .catch(function () {
        btn.textContent = 'Try again';
      })
      .then(function () {
        setTimeout(function () {
          btn.disabled = false;
          btn.textContent = label;
        }, 1800);
      });
  }

  /* ---------- 1b. Nút chọn màu / size ngay trên thẻ (15/10/2026) ----------
     Ô select gộp kiểu "M / Dark Chocolate — $35.95" (60 dòng với sweatshirt 6 size × 10 màu) khó
     chọn. Dựng mỗi option một hàng nút từ data-* của chính ô select rồi ẩn nó đi; select vẫn giữ
     biến thể đang chọn nên addDirect không phải đổi. */

  /* Tên màu của xưởng → mã màu hiển thị. Màu chưa có ở đây thì ra nút chữ. */
  var SWATCH = {
    'black': '#1b1b1b', 'white': '#ffffff', 'sport grey': '#a7a8aa', 'dark heather': '#414143',
    'sand': '#dccdb4', 'ash': '#e2e2de', 'military green': '#5e6447', 'dark chocolate': '#3b2a24',
    'indigo blue': '#3f5272', 'purple': '#4e2d6b', 'navy': '#1f2a44', 'maroon': '#5b1a24',
    'slategrey': '#708090', 'darkgreen': '#1e4d2b', 'indigo': '#3f51b5', 'red': '#b31b1b',
    'charcoal': '#4a4a4a', 'light blue': '#a9c6e0', 'light pink': '#f4c6d0', 'forest green': '#254a2f'
  };

  function enhancePicker(select) {
    var names = (select.getAttribute('data-option-names') || '').split('|');
    var variants = Array.prototype.map.call(select.options, function (o) {
      return { option: o, values: (o.getAttribute('data-options') || '').split('|') };
    }).filter(function (v) { return v.values.length === names.length; });
    if (variants.length < 2) return;

    var item = select.closest('.pf-pairs__item');
    var price = item.querySelector('.pf-pairs__price');
    var state = variants.filter(function (v) { return v.option.selected; })[0] || variants[0];
    state = state.values.slice();
    var groups = [];

    function match(values) {
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].values.join('|') === values.join('|')) return variants[i];
      }
      return null;
    }

    function render() {
      var current = match(state);
      if (!current) return;
      select.value = current.option.value;
      /* 16/10/2026: KHÔNG đổi ảnh theo màu nữa — áo sweatshirt chỉ 4/10 màu có ảnh riêng, chọn
         màu khác thì ảnh đứng yên, trông như lỗi (user bảo bỏ). Ảnh luôn là bộ ảnh gốc. */
      if (price) price.innerHTML = '<b>' + current.option.getAttribute('data-price') + '</b>';
      groups.forEach(function (g, i) {
        g.label.innerHTML = names[i] + ': <b></b>';
        g.label.querySelector('b').textContent = state[i];
        g.buttons.forEach(function (btn) {
          var value = btn.getAttribute('data-value');
          var probe = state.slice();
          probe[i] = value;
          btn.setAttribute('aria-pressed', value === state[i] ? 'true' : 'false');
          btn.disabled = !match(probe);
        });
      });
    }

    var wrap = document.createElement('div');
    wrap.className = 'pf-pairs__opts';
    /* Màu lên trước size: khách chọn màu xong mới chọn size (giống thẻ trên các sàn). */
    var order = names.map(function (n, i) { return i; }).sort(function (a, b) {
      return (/colou?r/i.test(names[b]) ? 1 : 0) - (/colou?r/i.test(names[a]) ? 1 : 0);
    });
    order.forEach(function (i) {
      var seen = [];
      variants.forEach(function (v) { if (seen.indexOf(v.values[i]) < 0) seen.push(v.values[i]); });
      var isColor = /colou?r/i.test(names[i]);
      var row = document.createElement('div');
      var label = document.createElement('div');
      label.className = 'pf-pairs__opt-label';
      var list = document.createElement('div');
      list.className = 'pf-pairs__opt-values';
      var buttons = seen.map(function (value) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.setAttribute('data-value', value);
        var hex = isColor && SWATCH[value.toLowerCase()];
        if (hex) {
          btn.className = 'pf-pairs__swatch';
          btn.style.background = hex;
          btn.title = value;
          btn.setAttribute('aria-label', value);
        } else {
          btn.className = 'pf-pairs__pill';
          btn.textContent = value;
        }
        btn.addEventListener('click', function () {
          state[i] = value;
          /* Tổ hợp không có (hết hàng) → lấy biến thể đầu tiên có giá trị vừa bấm. */
          if (!match(state)) {
            for (var k = 0; k < variants.length; k++) {
              if (variants[k].values[i] === value) { state = variants[k].values.slice(); break; }
            }
          }
          render();
        });
        list.appendChild(btn);
        return btn;
      });
      row.appendChild(label);
      row.appendChild(list);
      wrap.appendChild(row);
      groups[i] = { label: label, buttons: buttons };
    });

    select.hidden = true;
    select.parentNode.insertBefore(wrap, select);
    render();
  }

  /*
    16/10/2026 — dải ảnh trượt của mỗi món: vuốt bằng tay (scroll-snap của CSS), mũi tên trên
    desktop. (Chấm báo ảnh đang xem đã bỏ 16/10/2026 theo yêu cầu.)
  */
  function initGallery(media) {
    var track = media.querySelector('.pf-pairs__track');
    var slides = media.querySelectorAll('.pf-pairs__slide');
    var prev = media.querySelector('[data-pf-pairs-prev]');
    var next = media.querySelector('[data-pf-pairs-next]');
    if (!track || slides.length < 2) return;

    function index() {
      return Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
    }

    function update() {
      var i = index();
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= slides.length - 1;
    }

    function go(step) {
      track.scrollTo({ left: (index() + step) * track.clientWidth, behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    track.addEventListener('scroll', update, { passive: true });
    update();
  }

  Array.prototype.forEach.call(document.querySelectorAll('.pf-pairs [data-pf-pairs-gallery]'), initGallery);
  Array.prototype.forEach.call(document.querySelectorAll('.pf-pairs select[data-option-names]'), enhancePicker);

  /* ---------- 2. Hộp thoại cá nhân hoá ---------- */

  var EMBED_CSS =
    'header,footer,#header-group,#footer-group,.shopify-section-group-header-group,' +
    '.shopify-section-group-footer-group,.shopify-section-group-overlay-group,' +
    'main>.shopify-section:not([id$="__main"]),#chat-drawer,.pf-pairs,' +
    '.sticky-add-to-cart,sticky-add-to-cart,#cl-atc-modal{display:none!important}' +
    'html,body{background:#fff!important}' +
    /* Ở khổ hẹp Customily đặt nút Preview ngay trên nút Add to cart trong cùng
       add-to-cart-component, không có khoảng cách (đo 13/10/2026: 0px). */
    'add-to-cart-component>#customily-preview-button{margin-bottom:8px!important}';

  /* Chạy đầu <head> của khung, trước mọi script khác. */
  function embedBoot() {
    window.pfPairsEmbed = true;
    window.clAtcHold = true; /* cart-added-modal.js của khung: đừng mở popup trong khung */

    /* document là about:srcdoc — replaceState/pushState tới URL thật sẽ ném SecurityError. */
    ['replaceState', 'pushState'].forEach(function (name) {
      var native = history[name];
      history[name] = function () {
        try { return native.apply(history, arguments); } catch (e) { /* bỏ qua */ }
      };
    });

    /* Khung thấp nên Description / Returns & refunds nằm sát đáy: bấm mở thì nội dung bung ra
       dưới mép, khách tưởng không mở được (sếp báo 14/10/2026). Mở xong thì cuộn tiêu đề lên đầu. */
    document.addEventListener('click', function (e) {
      var summary = e.target.closest && e.target.closest('summary');
      if (!summary) return;
      setTimeout(function () {
        var details = summary.parentElement;
        if (!details || !details.open) return;
        if (summary.getBoundingClientRect().bottom > innerHeight * 0.6) {
          summary.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }
      }, 200);
    });

    var ADD = /\/cart\/add(\.js)?(\?|$)/;
    function report(text, qty) {
      try { parent.pfPairsAdded && parent.pfPairsAdded(text, qty); } catch (e) { /* bỏ qua */ }
    }

    /* Số lượng khách vừa thêm lấy từ thân request — `quantity` trong phản hồi là tổng của cả
       biến thể đang nằm trong giỏ, không phải số vừa thêm (đo 13/10/2026: thêm 1 mà trả 2). */
    function requestedQty(body) {
      try {
        if (!body) return 0;
        if (typeof body === 'string') {
          var text = body.trim();
          if (text.charAt(0) === '{') {
            var data = JSON.parse(text);
            return Number((data.items && data.items[0] ? data.items[0] : data).quantity) || 0;
          }
          return Number(new URLSearchParams(text).get('quantity')) || 0;
        }
        if (typeof body.get === 'function') return Number(body.get('quantity')) || 0;
      } catch (e) { /* không đọc được thì thôi */ }
      return 0;
    }

    if (window.fetch) {
      var nativeFetch = window.fetch;
      window.fetch = function (input, init) {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var promise = nativeFetch.apply(this, arguments);
        if (ADD.test(url)) {
          var qty = requestedQty(init && init.body);
          promise.then(function (r) {
            if (r && r.ok) r.clone().text().then(function (text) { report(text, qty); }).catch(function () {});
          }).catch(function () {});
        }
        return promise;
      };
    }

    var open = XMLHttpRequest.prototype.open;
    var send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.pfPairsAdd = ADD.test(String(url));
      return open.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function (body) {
      if (this.pfPairsAdd) {
        var qty = requestedQty(body);
        this.addEventListener('load', function () {
          if (this.status >= 200 && this.status < 300) {
            try { report(this.responseText, qty); } catch (e) { /* responseType khác text */ }
          }
        });
      }
      return send.apply(this, arguments);
    };
  }

  var TRACKER_SRC = /klaviyo|trustpilot|shop\.app\/|googletagmanager|google-analytics|connect\.facebook/i;
  var TRACKER_INLINE = /trekkie\.load|web-pixels-manager|_learnq|klaviyo|monorail|trustpilot/i;

  function buildSrcdoc(html, url) {
    html = html.replace(/<script\b([^>]*)>([\s\S]*?)<\/script>/gi, function (all, attrs, body) {
      var src = (attrs.match(/\bsrc=["']([^"']+)["']/i) || [])[1];
      if (src) return TRACKER_SRC.test(src) ? '' : all;
      if (/customily/i.test(body)) return all;
      return TRACKER_INLINE.test(body) ? '' : all;
    });
    var head =
      '<base href="' + url + '" target="_top">' +
      '<style>' + EMBED_CSS + '</style>' +
      '<script>(' + embedBoot.toString() + ')();<\/script>';
    return html.replace(/<head[^>]*>/i, function (m) { return m + head; });
  }

  var dialog;

  function ensureDialog() {
    if (dialog) return dialog;
    dialog = document.createElement('dialog');
    dialog.className = 'pf-pairs-dialog';
    dialog.innerHTML =
      '<div class="pf-pairs-dialog__bar"><span class="pf-pairs-dialog__title"></span>' +
      '<button type="button" class="pf-pairs-dialog__close" aria-label="Close">×</button></div>' +
      '<div class="pf-pairs-dialog__body"><div class="pf-pairs-dialog__loading">Loading…</div></div>';
    dialog.querySelector('.pf-pairs-dialog__close').addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
    dialog.addEventListener('close', function () {
      var frame = dialog.querySelector('iframe');
      if (frame) frame.remove(); /* dừng hẳn trang trong khung, giải phóng bộ nhớ */
    });
    document.body.appendChild(dialog);
    return dialog;
  }

  function openEmbed(link) {
    var url = new URL(link.getAttribute('href'), location.href).href;
    var dlg = ensureDialog();
    var body = dlg.querySelector('.pf-pairs-dialog__body');
    var loading = dlg.querySelector('.pf-pairs-dialog__loading');
    var old = body.querySelector('iframe');
    if (old) old.remove();
    dlg.querySelector('.pf-pairs-dialog__title').textContent = link.getAttribute('data-title') || '';
    loading.hidden = false;
    dlg.showModal();

    fetch(url, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('load failed');
        return r.text();
      })
      .then(function (html) {
        if (!dlg.open) return;
        var frame = document.createElement('iframe');
        frame.title = link.getAttribute('data-title') || 'Personalize';
        frame.addEventListener('load', function () { loading.hidden = true; });
        frame.srcdoc = buildSrcdoc(html, url);
        body.appendChild(frame);
        /* `load` chờ hết ảnh — trên mạng chậm quá lâu, nên mở màn che sớm hơn. */
        setTimeout(function () { loading.hidden = true; }, 2500);
      })
      .catch(function () {
        location.href = url;
      });
  }

  /* Khung gọi lên khi /cart/add trong khung thành công. */
  window.pfPairsAdded = function (text, qty) {
    var item = null;
    try {
      var data = JSON.parse(text);
      item = data && data.items ? data.items[0] : data;
    } catch (e) { /* phản hồi không phải JSON */ }
    if (dialog && dialog.open) dialog.close();
    refreshCount();
    if (item && item.id && typeof window.clAtcShow === 'function') window.clAtcShow(item, qty || 1);
  };

  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;
    var add = event.target.closest('[data-pf-pairs-add]');
    if (add) {
      if (!add.disabled) addDirect(add);
      return;
    }
    var embed = event.target.closest('[data-pf-pairs-embed]');
    if (!embed) return;
    if (event.ctrlKey || event.metaKey || event.shiftKey || event.button !== 0) return;
    if (!('srcdoc' in document.createElement('iframe')) || !window.HTMLDialogElement) return;
    event.preventDefault();
    openEmbed(embed);
  });
})();
